
export default {
  steps: {
    'instruction': 'Utasítás',
    'on': 'Ezen',
    'step': 'lépés',
    'gotoStep': 'Ugrás erre a lépésre:'
  }
}
